import { render, staticRenderFns } from "./NonSatsangiMemberList.vue?vue&type=template&id=bc8cff92&"
import script from "./NonSatsangiMemberList.vue?vue&type=script&lang=js&"
export * from "./NonSatsangiMemberList.vue?vue&type=script&lang=js&"
import style0 from "./NonSatsangiMemberList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports